import { FormLabel } from "../ui/form";
import { Button } from "../ui/button";
import {
  AlignCenterHorizontalIcon,
  AlignCenterVerticalIcon,
  AlignEndHorizontalIcon,
  AlignEndVerticalIcon,
  AlignStartHorizontalIcon,
  AlignStartVerticalIcon,
  BaselineIcon,
  StretchHorizontalIcon,
  StretchVerticalIcon,
} from "lucide-react";
import { FieldRender } from "@/lib/types";

export const FieldAlignItems: FieldRender<{ direction: "Row" | "Column" }> = ({
  field,
  title,
  direction,
}) => {
  return (
    <div className="flex gap-2">
      <FormLabel className="flex-grow">{title}</FormLabel>
      <div className="grid flex-shrink-0 grid-cols-3 grid-rows-2">
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "start" ? "default" : "secondary"}
          onClick={() => field.onChange("start")}
        >
          {direction === "Row" ? (
            <AlignStartHorizontalIcon />
          ) : (
            <AlignStartVerticalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "center" ? "default" : "secondary"}
          onClick={() => field.onChange("center")}
        >
          {direction === "Row" ? (
            <AlignCenterHorizontalIcon />
          ) : (
            <AlignCenterVerticalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "end" ? "default" : "secondary"}
          onClick={() => field.onChange("end")}
        >
          {direction === "Row" ? (
            <AlignEndHorizontalIcon />
          ) : (
            <AlignEndVerticalIcon />
          )}
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "baseline" ? "default" : "secondary"}
          onClick={() => field.onChange("baseline")}
        >
          <BaselineIcon />
        </Button>
        <Button
          size="iconSm"
          type="button"
          variant={field.value === "stretch" ? "default" : "secondary"}
          onClick={() => field.onChange("stretch")}
        >
          {direction === "Row" ? (
            <StretchHorizontalIcon />
          ) : (
            <StretchVerticalIcon />
          )}
        </Button>
      </div>
    </div>
  );
};
